export default {
  Underground: 0, 
  OpenPit: 1
};